import request from '@/utils/request'

// 查询北京鲁飞菜单列表
export function listBjlfmenu(query) {
  return request({
    url: '/system/bjlfmenu/list',
    method: 'get',
    params: query
  })
}

// 查询北京鲁飞菜单详细
export function getBjlfmenu(menuId) {
  return request({
    url: '/system/bjlfmenu/' + menuId,
    method: 'get'
  })
}

// 新增北京鲁飞菜单
export function addBjlfmenu(data) {
  return request({
    url: '/system/bjlfmenu',
    method: 'post',
    data: data
  })
}

// 修改北京鲁飞菜单
export function updateBjlfmenu(data) {
  return request({
    url: '/system/bjlfmenu',
    method: 'put',
    data: data
  })
}

// 删除北京鲁飞菜单
export function delBjlfmenu(menuId) {
  return request({
    url: '/system/bjlfmenu/' + menuId,
    method: 'delete'
  })
}
